import axios from 'axios'
import axiosRetry, { isNetworkError, isRetryableError } from 'axios-retry'
import { errorInterceptor, languageInterceptor } from './interceptors'

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 15000,
  withCredentials: true, // backend sets HttpOnly cookie with the JWT — sent automatically
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

// Retry only safe (idempotent) requests on transient network/5xx failures.
// Mutations (POST/PUT/PATCH/DELETE) are NEVER auto-retried — they may not be idempotent.
axiosRetry(http, {
  retries: 2,
  retryDelay: axiosRetry.exponentialDelay,
  shouldResetTimeout: true,
  retryCondition: (error) => {
    const method = (error.config?.method ?? 'get').toLowerCase()
    const isSafe = method === 'get' || method === 'head' || method === 'options'
    if (!isSafe) return false
    if (isNetworkError(error)) return true
    const status = error.response?.status ?? 0
    if (status === 429 || status === 502 || status === 503 || status === 504) return true
    return isRetryableError(error)
  },
})

http.interceptors.request.use(languageInterceptor)
http.interceptors.response.use((response) => response, errorInterceptor)
